module.exports = __webpack_public_path__ + "img/save.714168f6.svg";